interface Props {
  size?: number;
  color?: string;
}

const CoinsIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 24 24`}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M16.159 16.503a7.001 7.001 0 0 0-.938-13.938 7 7 0 0 0-6.937 6.062m7.937 6.938a7 7 0 1 1-14 0 7 7 0 0 1 14 0"
      ></path>
    </svg>
  );
};

export default CoinsIcon;
